var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFiberGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132.2 256.2",
    style: {
      enableBackground: "new 0 0 132.2 256.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BFBFBF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,0H96c-1.7,0-3,1.3-3,3v13.1c0,1.7,1.3,3,3,3h24c1.7,0,3-1.3,3-3V3C123,1.3,121.6,0,120,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.9,24.3H87.1c-1.9,0-3.4,1.5-3.4,3.4v52c0,0.9,0.3,1.7,0.9,2.3l8.1,8.4c0.3,0.3,0.6,0.5,1,0.7 c0,0.2-0.1,0.4-0.1,0.6v108.1c0,15.6-12.9,28.2-28.6,27.7c-15.1-0.4-26.9-13.2-26.9-28.3v-67.1c0.4-0.2,0.8-0.4,1.1-0.7l8.1-8.4 c0.6-0.6,0.9-1.5,0.9-2.3v-52c0-1.9-1.5-3.4-3.4-3.4H3.4c-1.9,0-3.4,1.5-3.4,3.4v52c0,0.9,0.3,1.7,0.9,2.3l8.1,8.4 c0.2,0.2,0.4,0.4,0.7,0.5v67c0,30.9,24.5,56.7,55.5,57.2c31.5,0.5,57.2-25,57.2-56.3V91.7c0-0.2,0-0.5-0.1-0.7 c0.3-0.2,0.6-0.4,0.8-0.6l8.1-8.4c0.6-0.6,0.9-1.5,0.9-2.3v-52C132.2,25.8,130.7,24.3,128.9,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.2,41h-24c-1.7,0-3,1.3-3,3v13.1c0,1.7,1.3,3,3,3h24c1.7,0,3-1.3,3-3V44C39.2,42.3,37.9,41,36.2,41z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFiberGrey);
export default __webpack_public_path__ + "static/media/icon-fiber_grey.b365463b66dbd7df66d68dd5019809bb.svg";
export { ForwardRef as ReactComponent };